// Import: Middleware Action & Custom Types
import { CLEAN_MUNICIPALITY, CLEAN_MUNICIPALITY_ERROR } from '_models/redux/types';

// Action function
export const cleanMunicipality = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      type: CLEAN_MUNICIPALITY,
      payload: undefined,
    });
  } catch (e) {
    dispatch({
      type: CLEAN_MUNICIPALITY_ERROR,
      payload: undefined,
    });
  }
};
